import styled from 'styled-components';

export const Div = styled.div`
  width: 600px;
  height: 500px;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  will-change: transform;
`;
